module.exports = __webpack_public_path__ + "static/img/12.bcd06d7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/6/1/sp/12.png
// module id = 7JnQ
// module chunks = 0